import { HOME } from "../../actions/home/home_action";

export const initState = {
  isDone: false,
  is_done: false,
  loading: false,
  list: [],
  errors: [],
  courses: [],
  certifications: [],
  certification: {},
  email_otp: "",
  mobile_otp: "",
};

const homeReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case HOME.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case HOME.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        certifications: [],
        courses: [],
        certification: {},
      };

    case HOME.ALL_HOME_TRAININGS:
      return {
        ...state,
        loading: false,
        errors: [],
        list: payload.list,
        courses: payload.courses,
        certifications: payload.certifications,
      };

    // case HOME.ALL_HOME_CERTIFICATION:
    //   return {
    //     ...state,
    //     loading: false,
    //     errors: [],
    //     certifications: payload,
    //   };
    case HOME.ALL_HOME_COURSES:
      return {
        ...state,
        loading: false,
        errors: [],
        courses: payload,
      };

    case HOME.SEARCH_HOME_COURSES:
      return {
        ...state,
        loading: false,
        errors: [],
        courses: payload,
      };

    case HOME.TRAINING_REGISTER:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done: true,
      };

    case HOME.SEARCH_HOME_CERTIFICATIONS:
      return {
        ...state,
        loading: false,
        errors: [],
        certifications: payload,
        certification: {},
      };

    case HOME.GET_CERTIFICATION_DETAILS:
      return {
        ...state,
        loading: false,
        errors: [],
        certifications: [],
        certification: payload,
      };
    case HOME.MOBILE_OTP:
      return {
        ...state,
        loading: false,
        mobile_otp: payload,
      };

    case HOME.EMAIL_OTP:
      return {
        ...state,
        loading: false,
        email_otp: payload,
      };

    default:
      return state;
  }
};

export default homeReducer;
